'use client'

import React, { useState } from 'react'
import HeaderFinal from '../components/HeaderFinal'
import Footer from '../components/Footer'

const PreguntasFrecuentesPage = () => {
  const [openCategory, setOpenCategory] = useState<string | null>('reservas')

  const faqData = [
    {
      id: 'reservas',
      title: '📋 RESERVAS Y PAGOS',
      questions: [
        {
          q: '¿Cómo puedo reservar un vuelo en Airlovers?',
          a: 'Para reservar necesitamos: 1) NOMBRE COMPLETO de cada persona, 2) PESO en kilos de cada persona, 3) EDAD de cada persona, 4) FECHA exacta deseada. Luego debes hacer un abono de $20,000 COP por persona.'
        },
        {
          q: '¿Cuál es el abono requerido?',
          a: 'El abono es de $20,000 COP por persona. Ejemplo: 4 personas = $80,000 COP de abono.'
        },
        {
          q: '¿Cuáles son los datos bancarios para el abono?',
          a: 'Banco: Bancolombia • Cuenta: 338-000083-61 • Titular: Club Escuela Deportiva Alas Doradas • NIT: 902.016.348-1 • Llave: 0091475224'
        },
        {
          q: '¿Reservan por hora específica?',
          a: 'NO. Reservamos por DÍA, no por hora. El vuelo depende 100% del clima y las condiciones meteorológicas.'
        },
        {
          q: '¿Qué pasa si el clima no permite volar?',
          a: 'Si el clima no permite volar, reprogramamos sin costo adicional. Tu abono queda válido para una nueva fecha.'
        }
      ]
    },
    {
      id: 'vuelos',
      title: '🪂 VUELOS Y EXPERIENCIAS',
      questions: [
        {
          q: '¿Qué tipos de vuelos ofrecen?',
          a: '1) VUELO RECREATIVO CLÁSICO ($255,000) - 15-20 min sin video • 2) VUELO RECREATIVO MAX ($300,000) - Incluye video GoPro • 3) VUELO RECREATIVO PRO MAX ($400,000) - Acrobacias + video'
        },
        {
          q: '¿Cuánto dura un vuelo?',
          a: 'Vuelo Clásico y Max: 15-20 minutos • Vuelo Pro Max: 20-25 minutos con acrobacias.'
        },
        {
          q: '¿Qué incluye cada vuelo?',
          a: 'Todos incluyen: equipo completo (parapente, arnés, casco), instructor certificado FEDEAEREOS, seguro de vuelo. Solo Max y Pro Max incluyen video GoPro.'
        },
        {
          q: '¿Hay restricciones de peso o edad?',
          a: 'Peso mínimo: 30 kg • Peso máximo: 120 kg • Edad mínima: 6 años (con autorización de padres).'
        },
        {
          q: '¿Necesito experiencia previa?',
          a: 'NO. Todos nuestros vuelos son para principiantes. El instructor maneja todo, tú solo disfrutas.'
        }
      ]
    },
    {
      id: 'ubicacion',
      title: '📍 UBICACIÓN Y HORARIOS',
      questions: [
        {
          q: '¿Dónde están ubicados?',
          a: 'Frente al Embalse del Tominé, Tocancipá, Cundinamarca. 45 minutos al norte de Bogotá.'
        },
        {
          q: '¿Cómo llego exactamente?',
          a: 'Usa Waze con este link preciso: https://waze.com/ul/hd2gkn61x6 • Coordenadas: 4°57\'N 73°54\'W'
        },
        {
          q: '¿Cuáles son los horarios de atención?',
          a: 'Lunes a viernes: 10:00 AM - 5:00 PM • Sábados, domingos y festivos: 9:00 AM - 5:30 PM'
        },
        {
          q: '¿Recomiendan llegar a alguna hora específica?',
          a: 'Sí, recomendamos llegar temprano. El vuelo depende del clima y las mejores condiciones suelen ser en la mañana.'
        },
        {
          q: '¿Hay parqueadero disponible?',
          a: 'Sí, tenemos parqueadero gratuito para nuestros clientes.'
        }
      ]
    },
    {
      id: 'grupos',
      title: '👥 GRUPOS Y EVENTOS ESPECIALES',
      questions: [
        {
          q: '¿Atienden grupos grandes?',
          a: 'Sí, atendemos grupos de hasta 15 personas. Para grupos de 4+ personas hay descuentos especiales.'
        },
        {
          q: '¿Ofrecen paquetes para cumpleaños?',
          a: 'Sí, tenemos 3 paquetes: Básico ($340,000), Premium ($365,000), Pro ($465,000). Incluyen vuelo Max y decoración especial.'
        },
        {
          q: '¿Puedo hacer una propuesta de matrimonio en el aire?',
          a: '¡Sí! Tenemos paquetes especiales para propuestas. Consulta la página de "Propuesta de matrimonio".'
        },
        {
          q: '¿Hay paquetes para aniversarios?',
          a: 'Sí, tenemos paquetes especiales para parejas. Consulta la página de "Aniversarios".'
        },
        {
          q: '¿Puedo regalar un bono de vuelo?',
          a: 'Sí, puedes regalar un bono. El beneficiario elige la fecha según disponibilidad.'
        }
      ]
    },
    {
      id: 'preparacion',
      title: '🎒 PREPARACIÓN Y RECOMENDACIONES',
      questions: [
        {
          q: '¿Qué debo llevar?',
          a: 'Ropa cómoda, zapatos cerrados, protector solar, gafas de sol, cámara/phone (opcional), buena actitud.'
        },
        {
          q: '¿Qué NO debo llevar?',
          a: 'Objetos sueltos que puedan caer, sandalias, ropa muy holgada, miedo a las alturas (¡bromeamos!).'
        },
        {
          q: '¿Es seguro volar en parapente?',
          a: 'Sí, extremadamente seguro. Usamos equipo certificado, instructores con más de 15 años de experiencia y seguimos todos los protocolos de seguridad.'
        },
        {
          q: '¿Puedo llevar mi propia cámara GoPro?',
          a: 'Sí, pero debes sujetarla correctamente. Nuestros instructores te indicarán cómo hacerlo de forma segura.'
        },
        {
          q: '¿Hay baños y vestidores disponibles?',
          a: 'Sí, tenemos baños y área para cambiarse.'
        }
      ]
    }
  ]

  const toggleCategory = (categoryId: string) => {
    setOpenCategory(openCategory === categoryId ? null : categoryId)
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 via-purple-900 to-black text-white">
      <HeaderFinal />
      
      {/* Hero Section */}
      <div className="relative pt-24 pb-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              PREGUNTAS FRECUENTES
            </h1>
            <p className="text-xl text-white/80 max-w-3xl mx-auto">
              Todo lo que necesitas saber para vivir la experiencia Airlovers
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="max-w-4xl mx-auto">
            {faqData.map((category) => (
              <div key={category.id} className="mb-6">
                <button
                  onClick={() => toggleCategory(category.id)}
                  className="w-full text-left bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300"
                >
                  <div className="flex items-center justify-between">
                    <h2 className="text-2xl font-bold">{category.title}</h2>
                    <span className="text-2xl">
                      {openCategory === category.id ? '−' : '+'}
                    </span>
                  </div>
                </button>
                
                {openCategory === category.id && (
                  <div className="mt-4 bg-black/30 rounded-2xl p-6 border border-white/10">
                    <div className="space-y-6">
                      {category.questions.map((item, index) => (
                        <div key={index} className="border-b border-white/10 pb-6 last:border-0 last:pb-0">
                          <h3 className="text-xl font-bold mb-3 text-blue-300">❓ {item.q}</h3>
                          <p className="text-white/90">{item.a}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Contacto adicional */}
          <div className="max-w-4xl mx-auto mt-16">
            <div className="bg-gradient-to-r from-blue-900/40 to-purple-900/40 rounded-3xl p-8 border border-blue-500/30">
              <div className="text-center">
                <h2 className="text-3xl font-bold mb-6">¿NO ENCUENTRAS TU RESPUESTA?</h2>
                <p className="text-xl text-white/80 mb-8">
                  Estamos aquí para ayudarte. Contáctanos directamente por WhatsApp
                </p>
                <a
                  href="https://wa.me/573028309637?text=¡Hola!%20Tengo%20una%20pregunta%20sobre%20Airlovers"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-2xl font-bold hover:shadow-2xl transition-all duration-300"
                >
                  <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981z"/>
                  </svg>
                  PREGUNTAR POR WHATSAPP
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default PreguntasFrecuentesPage